import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve an asset path to a full URL.
// - http(s): used as-is
// - /api/...: served by backend (uploaded/object-storage files)
// - /media/...: served by frontend static (bundled seed assets)
export const asset = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  if (path.startsWith('/api/')) return `${BACKEND_URL}${path}`;
  return path;
};

export const getContent = (collection) =>
  axios.get(`${API}/content/${collection}`).then((r) => r.data);

export const getItem = (collection, key) =>
  axios.get(`${API}/content/${collection}/${key}`).then((r) => r.data);

export const submitEnquiry = (formData) =>
  axios.post(`${API}/enquiries`, formData).then((r) => r.data);

// ------- Admin -------
const TOKEN_KEY = 'sle_admin_token';
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = (username, password) =>
  axios.post(`${API}/admin/login`, { username, password }).then((r) => r.data);

export const adminMe = () => axios.get(`${API}/admin/me`, authHeaders()).then((r) => r.data);
export const adminStatus = () => axios.get(`${API}/admin/status`, authHeaders()).then((r) => r.data);

export const adminCreate = (collection, body) =>
  axios.post(`${API}/admin/${collection}`, body, authHeaders()).then((r) => r.data);
export const adminUpdate = (collection, id, body) =>
  axios.put(`${API}/admin/${collection}/${id}`, body, authHeaders()).then((r) => r.data);
export const adminDelete = (collection, id) =>
  axios.delete(`${API}/admin/${collection}/${id}`, authHeaders()).then((r) => r.data);
export const adminUpdateSingleton = (collection, body) =>
  axios.put(`${API}/admin/singleton/${collection}`, body, authHeaders()).then((r) => r.data);

export const adminListEnquiries = () =>
  axios.get(`${API}/admin/enquiries`, authHeaders()).then((r) => r.data);
export const adminUpdateEnquiry = (id, body) =>
  axios.patch(`${API}/admin/enquiries/${id}`, body, authHeaders()).then((r) => r.data);
export const adminDeleteEnquiry = (id) =>
  axios.delete(`${API}/admin/enquiries/${id}`, authHeaders()).then((r) => r.data);

export const adminUpload = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return axios
    .post(`${API}/admin/upload`, fd, {
      headers: { Authorization: `Bearer ${getToken()}`, 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data);
};
